import React from 'react'
import TituloAreaCliente from './TituloAreaCliente'

const AreaClienteHome = () => {
  return (
    <section>
    </section>
  )
}

export default AreaClienteHome